import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo } from './data';
import { applyHead } from './head';
import { applySchema } from './schema';

// Single route-aware SEO/head manager. Runs on every route change and rewrites
// title, description, keywords, canonical, Open Graph, Twitter Card and JSON-LD
// so metadata from the previous route cannot leak into the next.
export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    const seo = resolveSeo(location.pathname, location.search);
    applyHead(seo.head);
    applySchema('seo-schema', seo.schema);
  }, [location.pathname, location.search]);

  return null;
}